import * as React from "react";
export class Arrow extends React.Component {
    constructor(props) {
        super(props);
        this.baseClass = "rj-racing-next-races__arrow";
    }
    render() {
        let cls = `${this.baseClass}${(this.props.classModifier ? ` ${this.baseClass}--${this.props.classModifier}` : "")}`;
        let dataUat = `${(this.props.classModifier ? `racing-next-arrow-${this.props.classModifier}` : "racing-next-arrow")}`;
        return (React.createElement("div", { onClick: this.props.handler, className: cls, "data-uat": dataUat }, this.props.text));
    }
}
//# sourceMappingURL=Arrow.js.map